function vzFoundationInit() {
  jQuery(document).foundation();
}
